import { useEffect } from 'react';
import { useNewStores } from '@/store/modules/agent-store';
import { eventBus, EventTypes } from '@/lib/event-bus';

/**
 * 设备连接/平台登录管理
 */
export function useDeviceConnection() {
  const { agentStore, deviceStore } = useNewStores();

  useEffect(() => {
    const handleClearDataSaver = () => {
      const selectedDataSaverCodes = Object.keys(
        agentStore.selectedAgentMap || {},
      )
        .filter((key) => {
          return agentStore.selectedAgentMap[key];
        })
        .filter((key) => {
          return (
            agentStore.agentList.find((a) => a.agent_name === key)?.datasaver_required
          );
        });
      if (selectedDataSaverCodes.length === 0) return;

      // 设备非 online：清空所有 DataSaver
      if (deviceStore.connectionStatus !== 'connected:online') {
        console.log(
          '[DeviceConnectionGuard] 设备不在线，清空所有DataSaver工具',
        );
        agentStore.removeAgents(selectedDataSaverCodes);
      }
    };

    // 设备完成了刷新之后，需要获取平台的状态，然后清空未登录的DataSaver工具
    return eventBus.on(EventTypes.DEVICE_FLUSH_FINISH, async () => {
      const platforms = agentStore.agentListDerived.platforms;
      // 只有设备状态是online且设备列表中有当前选择的设备，才需要刷新平台登录状态
      if (
        deviceStore.connectionStatus === 'connected:online' &&
        deviceStore.currentDevice.some(d => d.device_id === deviceStore.selectedDeviceId)
      ) {
        await deviceStore.detectPlatformsLoginStatus(platforms);
      }
      handleClearDataSaver();
    });
  });
}
